import React from 'react';

function DeleteCard() {
  return (
    <div className="main-container pt-3 pb-5">
      {/* Main Container that centers all elements on the page */}
      <div className="content-wrapper">
        {/* First div containing the title */}
        <div className="title delete-title ">
          <h1> <span className="orange-box"></span> Delete Profile</h1>
        </div>

        {/* Second div containing the card */}
        <div className="card delete-card">
          <h3>Are You Sure You Want To Delete Your Profile</h3>
          <p>This cant be undone</p>
          <p>Please enter your login password to confirm:</p>

          {/* Input field for entering password */}
          <input type="password" placeholder="Enter your password" className="password-input " />

          {/* Button for deleting the profile */}
          <button className="delete-button">Delete</button>
        </div>
      </div>
    </div>
  );
}

export default DeleteCard;
